import React from 'react';

import { BaseSvgIcon } from 'reactComponents/icons/_baseSvgIcon';

export default function IconEyeOff({
    width,
    height,
    className,
    onClick,
    tooltip,
    ...svgProps
}) {
    return (
        <BaseSvgIcon
            width={width}
            height={height}
            tooltip={tooltip}
            className={className}
            onClick={onClick}
            viewBox="0 0 24 24"
            pathD="M11.83 9L15 12.16V12a3 3 0 0 0-3-3h-.17m-4.3.8l1.55 1.55c-.05.21-.08.42-.08.65a3 3 0 0 0 3 3c.22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53a5 5 0 0 1-5-5c0-.79.2-1.53.53-2.2M2 4.27l2.28 2.28.45.45C3.08 8.3 1.78 10 1 12c1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-.3 4.38-.84l.43.42L19.73 22 21 20.73 3.27 3M12 7a5 5 0 0 1 5 5c0 .64-.13 1.26-.36 1.82l2.93 2.93c1.5-1.25 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-4 .7l2.17 2.15C10.74 7.13 11.35 7 12 7z"
            {...svgProps}
        />
    );
}
